function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M.5 0h52v52H.5z"
}), React.createElement("path", {
  stroke: "#3FC0C4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M17.862 4.7c11.678-5.04 25.314.152 30.456 11.599 5.143 11.444-.155 24.808-11.833 29.847-11.68 5.04-25.315-.153-30.457-11.597C.884 23.103 6.183 9.739 17.862 4.7z"
}), React.createElement("path", {
  stroke: "#3FC0C4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M48.352 34.387c-7.125 0-13.478-3.018-16.654-8.774-3.755-6.698-2.023-15.095 3.562-21.416M5.222 18.255c3.274 3.018 6.066 6.886 8.088 11.51 2.407 5.283 3.369 10.756 3.176 15.661m19.928.756c-5.776-3.774-11.36-10.285-15.018-18.587-3.563-8.02-4.813-16.039-3.947-22.644"
}), React.createElement("path", {
  stroke: "#3FC0C4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M47.39 14.48c-3.852 5.568-10.397 10.85-18.678 14.342-8.279 3.585-16.654 4.717-23.394 3.774"
}));

var SvgChilloutspace = function SvgChilloutspace(props) {
  return React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MyIgaGVpZ2h0PSI1MiIgdmlld0JveD0iMCAwIDUzIDUyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNLjUgMGg1MnY1MkguNXoiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiMzRkMwQzQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNMTcuODYyIDQuN2MxMS42NzgtNS4wNCAyNS4zMTQuMTUyIDMwLjQ1NiAxMS41OTkgNS4xNDMgMTEuNDQ0LS4xNTUgMjQuODA4LTExLjgzMyAyOS44NDctMTEuNjggNS4wNC0yNS4zMTUtLjE1My0zMC40NTctMTEuNTk3Qy44ODQgMjMuMTAzIDYuMTgzIDkuNzM5IDE3Ljg2MiA0Ljd6Ii8+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjM0ZDMEM0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTQ4LjM1MiAzNC4zODdjLTcuMTI1IDAtMTMuNDc4LTMuMDE4LTE2LjY1NC04Ljc3NC0zLjc1NS02LjY5OC0yLjAyMy0xNS4wOTUgMy41NjItMjEuNDE2TTUuMjIyIDE4LjI1NWMzLjI3NCAzLjAxOCA2LjA2NiA2Ljg4NiA4LjA4OCAxMS41MSAyLjQwNyA1LjI4MyAzLjM2OSAxMC43NTYgMy4xNzYgMTUuNjYxTTM2LjQxNCA0Ni4xODJjLTUuNzc2LTMuNzc0LTExLjM2LTEwLjI4NS0xNS4wMTgtMTguNTg3LTMuNTYzLTguMDItNC44MTMtMTYuMDM5LTMuOTQ3LTIyLjY0NCIvPgogICAgICAgIDxwYXRoIHN0cm9rZT0iIzNGQzBDNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik00Ny4zOSAxNC40OGMtMy44NTIgNS41NjgtMTAuMzk3IDEwLjg1LTE4LjY3OCAxNC4zNDItOC4yNzkgMy41ODUtMTYuNjU0IDQuNzE3LTIzLjM5NCAzLjc3NCIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgChilloutspace as ReactComponent };